<script setup lang="ts">
import { FireOutbreak } from '@/@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import HighestFireOutbreakMarker from './HighestFireOutbreakMarker.vue'
import FireOutbreakMarker from './FireOutbreakMarker.vue'
import Tooltip from '@/components/ui/tooltip/Tooltip.vue'
import FireOutbreakTooltip from './FireOutbreakTooltip.vue'
import { nextTick, ref, watch } from 'vue'

const props = defineProps<{
	alert: FireOutbreak
	// true quando o foco foi selecionado na lista lateral e o mapa terminou o zoom
	focused?: boolean
}>()

const tooltipRef = ref<InstanceType<typeof Tooltip>>()

watch(
	() => props.focused,
	async (focused) => {
		if (!focused) return
		await nextTick()
		tooltipRef.value?.show()
	},
)

function getMarkerContainer(tippyInstance: any): HTMLElement | null {
	return tippyInstance.reference?.closest('.mapboxgl-marker') ?? null
}

const tooltipOptions = {
	trigger: 'click',
	onShow(instance: any) {
		const marker = getMarkerContainer(instance)
		if (marker) marker.style.zIndex = '10'
	},
	onHide(instance: any) {
		const marker = getMarkerContainer(instance)
		if (marker) marker.style.zIndex = ''
	},
}
</script>

<template>
	<div class="w-fit">
		<tooltip
			ref="tooltipRef"
			:options="tooltipOptions"
			append-to="parent"
		>
			<template #trigger>
				<div @click="alert.haveSeenAlert()">
					<highest-fire-outbreak-marker v-if="!alert.seen" />
					<fire-outbreak-marker v-else />
				</div>
			</template>

			<fire-outbreak-tooltip :alert="alert" />
		</tooltip>
	</div>
</template>

<style scoped>
svg {
	cursor: pointer;
}
</style>
